import type { Subcategory } from '~/entities/categories'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { DOCUMENT_SERVER_STATUS } from '../config'
import { getDocumentStep } from './get-document-step'
import { getDocumentStepUrl } from './get-document-step-url'

export function getDocumentUrl(document: apiClient.Document, subcategories: Subcategory[]) {
  if (
    document.review_status === DOCUMENT_SERVER_STATUS.reviewed ||
    document.review_status === DOCUMENT_SERVER_STATUS.auto_reviewed
  ) {
    return getDocumentStepUrl(document.key, 'classification')
  }
  return getDocumentStepUrl(document.key, getDocumentStep(document, subcategories))
}
